var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"fa-2x",attrs:{"icon":"file-pdf"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }